import { FlexAligner, Switch, Typography } from '@scaleaq/scaleui';
import { useTranslation } from 'react-i18next';

import { useVideoRecall } from '@/hooks';
import { responsive } from '@/utils';

/**
 * Per-user toggle for HLS rewind (DVR). When the deployment `/config` flag disables
 * recall fleet-wide, the switch is forced off, disabled, and annotated.
 */
export const VideoRecallSettings = () => {
  const { t } = useTranslation();
  const { userEnabled, disabledByConfig, setEnableVideoRecall } = useVideoRecall();

  return (
    <FlexAligner direction='column' gap={responsive.spacing.xsmall}>
      <Typography type='buttontext_medium'>{t('videoRecall')}</Typography>
      <Switch
        label={disabledByConfig ? t('videoRecallDisabledByConfig') : t('videoRecallDescription')}
        checked={!disabledByConfig && userEnabled}
        onChange={() => setEnableVideoRecall(!userEnabled)}
        disabled={disabledByConfig}
      />
    </FlexAligner>
  );
};
